export const formRedirectDemandasMateriaLaboral = (url: string | undefined, token: string) => {
    if (!url) return;
    console.log(token);
    let form = document.createElement("form");
    form.setAttribute("target", "_blank");
    form.setAttribute("action", url);
    form.setAttribute("method", "POST");

    let hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", "token");
    hiddenField.setAttribute("value", token);
    form.appendChild(hiddenField);
    document.body.appendChild(form);
    form.submit();
}